import { apiClient } from "./client";

export interface AdbExplorerColumn {
  id: string;
  label: string;
  role: "axis" | "output";
  evidence?: "observed" | "model-conditioned";
  sample_count: number;
  min: number | null;
  max: number | null;
  mean: number | null;
  distinct_count?: number;
  held_default?: number | null;
  priority?: number;
}

export interface AdbExplorerLayer {
  id: string;
  label: string;
  evidence: "observed" | "model-conditioned";
  count: number;
}

export interface AdbCorrelationScore {
  field: string;
  label: string;
  r: number;
  evidence: "observed" | "model-conditioned";
}

export interface AdbExplorerPayload {
  project_id: string;
  branch: string;
  row_count: number;
  sample_count: number;
  outputs: AdbExplorerColumn[];
  axes: AdbExplorerColumn[];
  default_output: string | null;
  default_axes: { x: string | null; y: string | null };
  model_layers: AdbExplorerLayer[];
  rows: Record<string, unknown>[];
  correlations: Record<string, AdbCorrelationScore[]>;
  findings: string[];
  evidence: {
    raw_count: number;
    direct_count: number;
    compatible_count: number;
    corrected_count: number;
  };
  warnings: string[];
}

export async function fetchAdbExplorer(projectId: string, branch = "main", sampleLimit = 5000): Promise<AdbExplorerPayload> {
  const params = new URLSearchParams({ branch, sample_limit: String(sampleLimit) });
  return apiClient<AdbExplorerPayload>(`/projects/${projectId}/adb/explorer?${params.toString()}`);
}
